import { useQuery } from '@tanstack/react-query';
import { EmptyParametersError } from 'services/errors/EmptyParametersError';
import { queryKeys, RAW_ENDPOINTS, sdk } from 'utils/query';
import { PagedResult } from '@extrahorizon/javascript-sdk';
import { GroupCredit } from 'models/prescription';

const getGroupCredits = async (variables: { groupId?: string }): Promise<Record<string, number>> => {
  const { groupId } = variables;
  if (!groupId) throw new EmptyParametersError();

  const response = await sdk.raw.get<PagedResult<GroupCredit>>(`${RAW_ENDPOINTS.PRESCRIPTIONS}/groups?id=${groupId}`);
  if (!response.data.data[0].creditBalances) {
    return {};
  }
  return response.data.data[0].creditBalances.reduce((accumulator, currentValue) => {
    return {
      ...accumulator,
      [currentValue.packageId]: currentValue.balance,
    };
  }, {});
};

export const useGroupCredits = (groupId?: string) =>
  useQuery({
    queryKey: [queryKeys.packages, groupId],
    queryFn: () => getGroupCredits({ groupId }),
    enabled: !!groupId,
  });
